import { ServiceStatus } from "@/enums/ServiceStatus";

export const getStatusColor = (status) => {
  switch (status) {
    case ServiceStatus.Archived:
      return '#e0e0e0';
    case ServiceStatus.Approved:
      return '#4caf50';
    case ServiceStatus.Rejected:
      return '#f44336';
    case ServiceStatus.AwaitingApproval:
    case ServiceStatus.Cancelled:
      return '#ff9700';
    case ServiceStatus.Completed:
      return '#3f51b5';
    default:
      return '#000000';
  }
};